import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicProgramDto extends EpimsBaseEntityDto {
  ProgramName: string;
  SubscriberEmail: string;
  SubscriptionUserId: string;
  Version: number;
}
